<template>
    <div class="w3-margin">
        <h4 class="page-title">TELJESÍTÉSI ADATLAP</h4>          
        <div v-if="certify" class="w3-padding w3-center w3-border-top w3-border-left w3-border-right"> 
            <div class="uppercase">{{certify.userName}}</div>
            <div class="uppercase">{{certify.hikeName}}</div>
            <div class="w3-small">
                <font-awesome-icon class="w3-text-black" v-if="certify.status==0" icon="angle-double-right"></font-awesome-icon>
                <font-awesome-icon class="w3-text-blue" v-if="certify.status==1" icon="history"></font-awesome-icon>
                <font-awesome-icon class="w3-text-green" v-if="certify.status==2" icon="check-circle"></font-awesome-icon>
                <font-awesome-icon class="w3-text-red" v-if="certify.status==3" icon="times-circle"></font-awesome-icon>
                <font-awesome-icon class="w3-text-red" v-if="certify.status==4" icon="times-circle"></font-awesome-icon> 
                        {{certify.status | filterNumberToStatus}}
            </div>
        </div>    
        <table v-if="certTable" class="w3-table-all w3-small">
            <tr class="theme-1">
                <td >#</td>
                <td >Ellenőrző pont</td>
                <td class="w3-center">Áthaladási idő</td>
                <td class="w3-hide-small w3-center">Eltelt idő</td>                    
                <td class="w3-hide-small w3-center">Megtett táv</td>
                <td class="w3-hide-small w3-center">Átlagsebesség</td>
            </tr>                
            <tr class="" v-for="(item, index) in certTable" :key="index">
                <td>{{index+1}}.</td>
                <td>{{item.name}}</td>
                <td class="w3-center">{{item.date | filterDateTimeFormat}}</td>
                <td class="w3-hide-small w3-center">{{item.time | filterNumberToTime2}}</td>                    
                <td class="w3-hide-small w3-center">{{item.dist | filterNumberToDist}}</td>
                <td class="w3-hide-small w3-center">{{item.avgSpeed | filterAvgSpeed}}</td>
            </tr>
        </table>
    </div>
</template>

<script>
import "../filters.js";
const fb = require('../firebase.js');
export default {
    name: 'DisplayCertify',
    data(){
        return{
            certify:null,
            certTable:null,
        }
    },
    methods:{
        addSubSum(plist){
            var sumDist=0;
            var sumLevel=0;
            for (var i in plist){
                sumDist+=plist[i].prevDist;
                sumLevel+=plist[i].prevLevel;
                plist[i].sumDist=sumDist;
                plist[i].sumLevel=sumLevel;
            }
            return plist;
        }, 
 
       sortPointList(points,type) {
            var orderedList=points.sort((a,b) => (a.ordernum > b.ordernum) ? 1 : ((b.ordernum > a.ordernum) ? -1 : 0));            
            if (type==1) {
                var lastRow = Object.assign({}, orderedList[0]);
                orderedList.push(lastRow);
                orderedList[0].prevDist=0;
                orderedList[0].prevLevel=0;
            }
            return this.addSubSum(orderedList);
        },  
 
        showUserCertify(item){
            this.$showSpinner();
            var avgSpeed=0; 
            if (item.sumtime>0) avgSpeed=item.distance/(item.sumtime/3600);
            fb.GetPoints2(item.hikeId).then(r=>{
                var plist=[];
                for (var i in r) {
                    plist.push(r[i]);
                }                
                this.aktPoints=this.sortPointList(plist,item.type);
                fb.GetUserCertify(item.id,this.aktPoints).then(res=>{
                    this.certTable=res[0];
                    var l=this.certTable.length;
                    if (item.status>1) {
                        this.certTable[l-1].avgSpeed=avgSpeed;
                        this.certTable[l-1].time=item.sumtime;
                        this.certTable[l-1].date=item.enddate;
                    } else {
                        this.certTable[l-1].avgSpeed=null;
                        this.certTable[l-1].time=null;
                        this.certTable[l-1].date=null;
                        this.certTable[l-1].dist=null;
                    }
                    this.certify=res[1];
                    this.$hideSpinner();

                })
                .catch(e=>{
                    console.log(e);
                });	       
            }).catch(e=>{
                console.log(e);
            }); 
        },

    },
    mounted: function(){
        this.showUserCertify(this.$route.params.cert);
    }
}
</script>